import * as dateUtil from '../../../../../dateUtil/dateUtil';

export async function applyReceiptEndorsement(sale, receiptPrintPayload, saleEndorsement)
{
    if (saleEndorsement.isError)
        return;

    const date = dateUtil.formatDate(dateUtil.convertToLocalStandard(sale.dateTime), dateUtil.internalDateFormat);

    const { responseData } = saleEndorsement;

    const endorsementReceipt = {};

    endorsementReceipt.header =
        `Invoice No: ${responseData.invoice_number} dated ${date}\n` +
        `CU Invoice No: ${responseData.cu_invoice_number}\n` +
        `CU Serial No: ${responseData.cu_serial_number}`;

    // endorsementReceipt.header = `Invoice Number: ${responseData.invoice_number} dated ${date}`;
    endorsementReceipt.qrCode = responseData.verify_url;
    endorsementReceipt.footer = `Verify tax-paid invoice by scanning QR Code`;

    receiptPrintPayload.endorsements.push(endorsementReceipt);
}